import * as helperStorage from '../common/util/storage';
import {getEnvironment, credentials, removeCredentials, getPaymentProcessorBaseURL,isUSSite} from "../util/helpers";

import { localePath } from "../util/internationalization";
import pick from 'lodash/pick';
import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';

export const US_ACRONYMUN = "US";

export const DONATION_PROGRAMS = {
  default: {
    project_fund_code: "Vision2033-Q",
    project_title: "Vision 2033",
    outreach: 'FCBH'
  },
  recordings: {
    project_fund_code: "FCBH-L",
    project_title: "Bible Recordings",
    outreach: 'FCBH'
  },
  programs: {
    project_fund_code: "FCBH-N",
    project_title: "Field Programs",
    outreach: 'FCBH'
  }
};

export const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const REGEX_TEXT = /^(['À-ÿa-zA-Z\/\s])*$/;

export const REQUIRED_FIELDS = {
    first_name: "First Name",
    last_name: "Last Name",
    address_state: "State",
    address_street: "Address",
    address_city: "City",
    address_zip: "Zip Code",
    phone: "Phone Number",
    email: "Email",
    card_num: "Card Number",
    card_expiration: "Card Expiration",
    card_security_code: "CVV/CVC code",
    company_name: "Company Name or Organization Name",
};

export const REQUIRED_PLEDGE_FIELDS = { ...pick( REQUIRED_FIELDS, [ "first_name", "last_name", "phone", "email"] ) };

export const ERROR_MESSAGES = {
    name: "can only be letters.",
    email: "is not valid.",
    card_num: "Please enter a valid credit card number.",
    card_expiration: "Please enter a valid expiration date.",
    company_name: "must have at least 3 characters.",
    default: "is required.",
    amount: "You must select or enter an amount higher than zero.",
    agreement: "You must accept the agreement to duplicate your impact through the Vision 2033 Matching Challenge",
}

export const SELF_VALIDATING_FIELDS = [
    "company",
    "card_num",
    "card_expiration",
    "email",
];

export const US_PATTERNS = {
  zip_code: /^\d{5}(-\d{5})?$/,
}

export function AddAcceptJsTag() {
    if (getEnvironment() === 'staging') {
      AcceptJsSandboxTag(); //TODO - uncomment when backt o test from Alt
     // AcceptJsTag(); //TODO - remove when back to test from Alt
    } else {
      AcceptJsTag();
    }
}

function AcceptJsTag() {
  const script = document.createElement("script");
  script.src = "https://js.authorize.net/v1/Accept.js";
  script.type = "text/javascript";
  script.charset = 'utf-8';
  document.head.append(script);
}

 function AcceptJsSandboxTag() {
  const script = document.createElement("script");
  script.src = "https://jstest.authorize.net/v1/Accept.js";
  script.type = "text/javascript";
  script.charset = 'utf-8';
  document.head.append(script);
}
const DEFAULT_ROUTE_TO_REDIRECT = '/get-involved';

const CAMPAIGN_ROUTE_REDIRECT = {
  default: {
    success: `${DEFAULT_ROUTE_TO_REDIRECT}/success`,
    error: `${DEFAULT_ROUTE_TO_REDIRECT}/error`,
    pending: `${DEFAULT_ROUTE_TO_REDIRECT}/pending`,
  },
  fcbh: {
    success: `${DEFAULT_ROUTE_TO_REDIRECT}/success`,
    error: `${DEFAULT_ROUTE_TO_REDIRECT}/error`,
    pending: `${DEFAULT_ROUTE_TO_REDIRECT}/pending`,
  },
  givingtuesday: {
    success: '/giving-tuesday-success',
    error: `${DEFAULT_ROUTE_TO_REDIRECT}/error`,
    pending: `${DEFAULT_ROUTE_TO_REDIRECT}/pending`,
  },
  mmchallengedonor: {
    success: '/success-mm-donors',
    error: `${DEFAULT_ROUTE_TO_REDIRECT}/error`,//`/error-mm-donor`,
    pending: `${DEFAULT_ROUTE_TO_REDIRECT}/pending`,
  },
  fcbh_asia_temp: {
    success: '/asia/campaigns/success',
    error: '/asia/campaigns/error',
    pending: '/asia/campaigns/pending',
  },
  fcbh_asia: {
    success: '/get-involved/success',
    error: '/get-involved/error',
    pending: '/get-involved/pending',
  },
};
 const PAYMENT_STATUS = [
    "success",
    "error",
    "pending",
];
const convertDataToNodes = (data) => {
    const container = document.createElement('div');
    container.innerHTML = data;
    
    return container;
};

const saveFormInStorage = (transactionId, localForm = helperStorage.GIVE_FORM) => {

    const currentForm = helperStorage.getFromStorage(localForm) || {};
    
    const newForm = {
        ...currentForm,
        transactionId
    };

    helperStorage.saveToStorage(localForm, newForm);
};

const manageStorage = ( errorText, mustRedirectTo, isDonorUpdate = false) => {
    helperStorage.deleteFromStorage(helperStorage.PAYMENT_ERROR);
    helperStorage.saveToStorage(helperStorage.PAYMENT_ERROR, { errorText, mustRedirectTo, isDonorUpdate });
}

const saveErrorInStorage = (msg, mustRedirectTo, details = [], isDonorUpdate = false) => {
    let errorText = [msg];
    details.forEach((text) => {if (text) errorText.push(text);});
    manageStorage( errorText, mustRedirectTo, isDonorUpdate);
};

const savePayPalErrorInStorage = (mustRedirectTo) => {
    const errorText = "An error occurred during the transaction, please try again."
    manageStorage( errorText, mustRedirectTo);
};

const responseTypes = {
    success: {
        route: 'success',
        action: saveFormInStorage
    },
    decline: {
        route: 'error',
        action: saveErrorInStorage
    },
    fail: {
        route: 'error',
        action: saveErrorInStorage
    },
    pending: {
        route: 'pending',
    }
};

const PAYMENT_PROCESS = {
  process:              `${getPaymentProcessorBaseURL()}/PaymentsUniversal/Process`,
  pledge:               `${getPaymentProcessorBaseURL()}/PaymentsUniversal/Pledge`,
  store:                `${getPaymentProcessorBaseURL()}/Store/StoreTransaction`,
  upgrade:              `${getPaymentProcessorBaseURL()}/PaymentsUniversal/DonorUpdateDonation`,
  authNetClientConfig:  `${getPaymentProcessorBaseURL()}/PaymentsUniversal/AuthNetConfig`,
  apiLoginID: getEnvironment() === 'staging'? "8EY9BdWy9qF": "79J4GjyTq8",
  clientKey:  getEnvironment() === 'staging'? "9e6F53b9hTKAShjkDnYDc8dWpk2Xn6fQ9q5h3R3s7k7B3WmPbwv52LZSBWkwj3RD": "3Tvady8EQ5ac46y388Fr2vM2sJU5aaP3M2jWdZxBQ24v5vMxYuspFE9Kse5Z4cAB",
  staging: {
    process: `${getPaymentProcessorBaseURL()}/PaymentsUniversal/Process`,
    pledge:  `${getPaymentProcessorBaseURL()}/PaymentsUniversal/Pledge`,
    store:   `${getPaymentProcessorBaseURL()}/Store/StoreTransaction`,
    upgrade: `${getPaymentProcessorBaseURL()}/PaymentsUniversal/DonorUpdateDonation`,

    authNetClientConfig: `${getPaymentProcessorBaseURL()}/PaymentsUniversal/AuthNetConfig`,
    apiLoginID: "8EY9BdWy9qF",//"5T8uW5qT", //"957EvjdB46T",
    clientKey:  "9e6F53b9hTKAShjkDnYDc8dWpk2Xn6fQ9q5h3R3s7k7B3WmPbwv52LZSBWkwj3RD", // "962594eDNf7qRk54WqhEfKw9xMZ562LUMCm3RsVt7Qn6PQeYG8qTVBx2t8V6TdxB",

  },
};
export const getAuthNetClientConfigURL = (type = "authNetClientConfig") => {
  return PAYMENT_PROCESS[type];
}

export const DEFAULT_REDIRECT_PARAMS = {mustRedirectTo: window.location.pathname, campaign: "default", isDonorUpdate: false}

const getPaymentResponseType = (status) => {
    return responseTypes[status] || responseTypes.success;
};
export const getPaymentProcessorURL = (type = "process") => {
  return PAYMENT_PROCESS[type];
}

export const redirectByResponse = ({ data }, params = DEFAULT_REDIRECT_PARAMS, localForm = helperStorage.GIVE_FORM) => {
    const campaign = params?.campaign? params.campaign.split('?')[0] : null;
    const { data: { detailed_messages, response_reason_text, transaction_id}, status } = typeof data == 'string'? JSON.parse( data ): data;
    const responseType = getPaymentResponseType(status); 
    const redirectTo = params?.mustRedirectTo?? window.location.pathname;
    let campaignRoute =campaign? campaign.replace(/[^\w]/gi, "") : "default"; 
    if (campaignRoute =='fcbh_asia' && isUSSite()) campaignRoute = 'fcbh_asia_temp';

    let errorText = [];
    if(!data) {
        errorText.push("An error occurred while sending the form, please try again later.");
        response_reason_text = "Generic error";

    } else if (Array.isArray(detailed_messages)) {
        detailed_messages.forEach((text) => {if (text) errorText.push(text);});
    } else if (detailed_messages) {
        errorText.push(detailed_messages);
    }

    status == 'success'? responseType?.action?.(transaction_id, localForm) : responseType?.action?.(response_reason_text, redirectTo, errorText, params.isDonorUpdate) ;

    let campaignRouteFinal = CAMPAIGN_ROUTE_REDIRECT[campaignRoute]? CAMPAIGN_ROUTE_REDIRECT[campaignRoute][responseType.route] : CAMPAIGN_ROUTE_REDIRECT['default'][responseType.route];

    window.location = getInitialPath() + campaignRouteFinal;
};

const getInitialPath = () => {
    if (window.location.hostname.startsWith("localhost") ) {
      let pathParts = window.location.pathname.split("/");
        return `/${pathParts[1]}`;
    }
    return "";
}

export const redirectByResponsePayPal = (isError, params = DEFAULT_REDIRECT_PARAMS) => {
    const campaign = params?.campaign? params.campaign.split('?')[0] : null;
    const redirectTo = params?.mustRedirectTo?? window.location.pathname;
    let campaignRoute = campaign? campaign.replace(/[^\w]/gi, "") : "default";
    if (campaignRoute =='fcbh_asia' && isUSSite()) campaignRoute = 'fcbh_asia_temp';
    if ( isError ) savePayPalErrorInStorage( redirectTo );
    let campaignRouteFinal = isError
        ? CAMPAIGN_ROUTE_REDIRECT[campaignRoute]["error"]
        : CAMPAIGN_ROUTE_REDIRECT[campaignRoute]["success"];
    window.location = getInitialPath() + campaignRouteFinal;
}

export const getRedirectUrlByStatusAndOutreach = (status, outreach = "fcbh") => {
    let campaign = outreach? outreach.toLowerCase() :  "default";
    if (campaign =='fcbh_asia' && isUSSite()) campaign = 'fcbh_asia_temp';
    let campaignRouteFinal = PAYMENT_STATUS.includes(status)
        ? CAMPAIGN_ROUTE_REDIRECT[campaign][status]
        : CAMPAIGN_ROUTE_REDIRECT[campaign]["error"];
    return getInitialPath() + localePath() + campaignRouteFinal;
}

export const formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.error(e)
    }
};

export const getMetaValues = ( metaName ) => document.querySelector(`meta[name="${metaName}"]`)?.content?.split("#");

export const isPledgeInput = ( inputId ) => !!inputId?.toLowerCase()?.includes( "pledge" );

export const isAmountLessThanZero = ( amount ) => amount <= 0 || isNaN( amount ) || isNil( amount );

export const getMoneyValue = ( value ) => formatMoney( String( value ).replace(',', '') );

export const isCCValid = ( value ) => {
    value = value.replace(/\D/g, "");

    if (value.length < 13 || value.length > 19) {
      return false;
    }

    let lastDigit = value.slice(-1);

    value = value.slice(0, -1);
    value = value.split("").reverse();

    let total = 0;

    for (let index = 0; index < value.length; ++index) {
      if (index % 2 == 0) {
        value[index] = value[index] * 2;
      }

      if (value[index] > 9) {
        value[index] = value[index] - 9;
      }

      total = Number(total) + Number(value[index]);
    }
    total = Number(total) * 9;

    return total % 10 == lastDigit ? true : false;
}

export const isExpirationValid = ( value ) => {
    value = value.replace(/\D/g, "");

    if (value.length != 4 && value.length != 6) {
      return false;
    }

    const expMonth = value.slice(0, 2);
    const expYear = value.slice(-2);
    const date = new Date();
    const currentMonth = Number(date.getMonth()) + 1;
    const currentYear = date.getFullYear().toString().slice(-2);

    if (expYear == currentYear && expMonth < currentMonth) {
      return false;
    }

    if (expYear < currentYear) {
      return false;
    }

    if (expMonth < 1 || expMonth > 12) {
      return false;
    }

    return true;
}

export const getFormToSend = ( data ) => Object.keys( data ).reduce( (formData, key ) => {
        formData.append( key, currentData[key] );
        return formData;
    }, new FormData());

export const capturePaymentError = ( error ) => {
    console.error(error);

    return error.message === "Failed Donation"
        ? "There was an error processing your payment, please try again later."
        : "An error occurred while sending the form, please try again later.";
}


export const fcbhCredentials = async (newCredential = true) => {
  return await credentials(newCredential);
};

export const removeFcbhCredentials = async () => {
  return await removeCredentials();
};
